import { render } from "./EditNotificationPage.vue?vue&type=template&id=52b20c38&ts=true"
import script from "./EditNotificationPage.vue?vue&type=script&lang=ts"
export * from "./EditNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__